$(window).on("load", () => {

    //--------------------- loader -----------------------

    setTimeout(function () {
        $('#loader').removeClass('active')
    }, 50)

    //----------------------- factory aos disable --------------------

    if ($(window).height() < 830) {
        $('#forms').attr('data-aos-delay', 0)
    }

});

function getLocale() {
    return window.locale;
}

function getLocalPart() {
    if (getLocale() === 'uk') {
        return ''
    }

    return '/' + getLocale();
}

$(document).ready(() => {
    //-------------------- validate translation ------------------------

    let fill
    let maximumLength
    let minimumLength

    if (getLocale() === 'en') {
        fill = 'This field is required'
        maximumLength = 'The maximum number of characters is '
        minimumLength = 'The minimum number of characters is '
    } else if (getLocale() === 'ru') {
        fill = 'Это обязательное поле'
        maximumLength = 'Максимальное количество символов '
        minimumLength = 'Минимальное количество символов '
    } else {
        fill = 'Це обов\'язкове поле'
        maximumLength = 'Максимальна кількість символів '
        minimumLength = 'Мінімальна кількість символів '
    }


    //------------------- header search ----------------------

    $('#search').on('click', function () {
        $('#search-input').toggleClass('hide')
        $('#header-numbers').toggleClass('hide')
        $('#search-dropdown').addClass('hide')
        if ($(window).innerWidth() < 951 ) {
            $('.mobilesearch').toggleClass('open')
            $('#header-left').toggleClass('hide');
            $('#header-right').toggleClass('hide');
            $('#hamburger').toggleClass('hide');
            $('.header-wrapper').toggleClass('mobile');
        }
    })
    $('#search-input').find('.svg-wrap').on('click', function () {
        $('#search-input').addClass('hide')
        $('#header-numbers').removeClass('hide')
        $('#search-dropdown').addClass('hide')
    })
    $('#search-input').find('input').on('input', function () {
        $('#search-dropdown').addClass('hide')
        $.ajax({
            type: 'GET',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                'X-localization': getLocale()
            },
            url: '/api/v1/products/search',
            data:  { search: $(this).val() }
        }).done(function (response) {
            if (response.data.length > 0 ) { $('#search-dropdown').removeClass('hide')}
            $('#search-dropdown').children().remove()
            response.data.forEach(el => {
                title = el.title
                slug = el.slug
                let item = `<object><a href="${(getLocalPart())}/product/${slug}" class="search-dropdown-link">${title}</a></object>`
                $('#search-dropdown').append(item)
            })
        })
    })
    $('#search-input-mob').find('input').on('input', function () {
        $('#search-dropdown-mob').addClass('hide')
        $.ajax({
            type: 'GET',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                'X-localization': getLocale()
            },
            url: '/api/v1/products/search',
            data:  { search: $(this).val(), take:5 }
        }).done(function (response) {
            if (response.data.length > 0 ) { $('#search-dropdown-mob').removeClass('hide')}
            $('#search-dropdown-mob').children().remove()
            response.data.forEach(el => {
                title = el.title
                slug = el.slug
                let item = `<object><a href="${(getLocalPart())}/product/${slug}" class="search-dropdown-link">${title}</a></object>`
                $('#search-dropdown-mob').append(item)
            })
        })
    })
    $('#search-input-mob').find('.svg-wrap-mob').on('click', function () {
        $('.mobilesearch').toggleClass('open')
        $('#header-left').toggleClass('hide');
        $('#header-right').toggleClass('hide');
        $('#hamburger').toggleClass('hide');
        $('.header-wrapper').toggleClass('mobile');
    })

    //------------------- main page catalog ----------------------

    $('#main-categories').find('div').on('click', function () {
        $('#main-categories').find('div').removeClass('active')
        $(this).addClass('active')
            let data = {
                take: 10,
                popular: true,
                category:  $(this).attr('data-category-slug'),
            }
            $.ajax({
                type: 'GET',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                    'X-localization': getLocale()
                },
                url: '/api/v1/products/filter',
                data:  data
            }).done(function (response) {
                $('#main-catalog').slick('unslick')
                $('#main-catalog').children().remove()
                response.data.forEach(el => {
                    image = el.image
                    title = el.title
                    slug = el.slug
                    capacity = el.capacity
                    let item = `
                        <div class="catalog-item__wrap">
                            <a href="${(getLocalPart())}/product/${slug}" class="catalog-item">
                                <div class="catalog-item__photo">
                                    <img src="${image}" alt="${title}">
                                </div>
                                <div class="catalog-item__info">
                                    <div class="info-title">${title}</div>
                                    <div class="info-options">
                                        <div class="info-options__item">
                                            <div class="option-name">${capacity?.name ?? ''}</div>
                                            <div class="option-dash"></div>
                                            <div class="option-param">${capacity?.value ?? ''}</div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div> `
                    $('#main-catalog').append(item)
                })
                initCatalogSlider()
            })
    })
    function initCatalogSlider () {
        $('#main-catalog').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: false,
            accessibility: true,
            autoplay: false,
            draggable: true,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1250,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 950,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ],
        })
    }
    initCatalogSlider()
    //------------------- main page trust ----------------------

    $('#main-trust').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows: false,
        accessibility: true,
        autoplay: false,
        draggable: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1250,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 950,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 525,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ],
    })

    //------------------- catalog ----------------------

    $('#categories').find('div').on('click', function () {
        $('#categories').find('div').removeClass('active')
        $(this).addClass('active')
        $('#categories').attr('data-category-slug', $(this).attr('data-category-slug'))
        $('#catalog-load').removeClass('hide')
        $('#catalog').attr('data-count', 0)
        let data = {
            category: $('#categories').attr('data-category-slug'),
            sort:   Number($('#sort').attr('data-sort-id'))
        }
        $.ajax({
            type: 'GET',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                'X-localization': getLocale()
            },
            url: '/api/v1/products/filter',
            data:  data
        }).done(function (response) {
            $('#catalog').attr('data-count', (Number($('#catalog').attr('data-count')) + response.data.length))
            $('#catalog').children().remove()
            response.data.forEach(el => {
                image = el.image
                title = el.title
                slug = el.slug
                capacity = el.capacity
                let item = `<a href="${(getLocalPart())}/product/${slug}" class="catalog-item">
                            <div class="catalog-item__photo">
                                <img src="${image}" alt="${title}">
                            </div>
                            <div class="catalog-item__info">
                                <div class="info-title">${title}</div>
                                <div class="info-options">
                                    <div class="info-options__item">
                                        <div class="option-name">${capacity?.name ?? ''}</div>
                                        <div class="option-dash"></div>
                                        <div class="option-param">${capacity?.value ?? ''}</div>
                                    </div>
                                </div>
                            </div>
                        </a>`
                $('#catalog').append(item)
            })
            if (response.data.length < 8) { $('#catalog-load').addClass('hide')}
        })
    })

    $('#catalog-load').on('click', function () {
        let data = {
            skip:Number($('#catalog').attr('data-count')),
            take: 8,
            category: $('#categories').attr('data-category-slug'),
            sort:   Number($('#sort').attr('data-sort-id'))
        }
        $.ajax({
            type: 'GET',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                'X-localization': getLocale()
            },
            url: '/api/v1/products/filter',
            data:  data

        }).done(function (response) {
            $('#catalog').attr('data-count', (Number($('#catalog').attr('data-count')) + response.data.length))
            response.data.forEach(el => {
                image = el.image
                title = el.title
                slug = el.slug
                capacity = el.capacity
                let item = `<a href="${(getLocalPart())}/product/${slug}" class="catalog-item">
                            <div class="catalog-item__photo">
                                <img src="${image}" alt="${title}">
                            </div>
                            <div class="catalog-item__info">
                                <div class="info-title">${title}</div>
                                <div class="info-options">
                                    <div class="info-options__item">
                                        <div class="option-name">${capacity?.name ?? ''}</div>
                                        <div class="option-dash"></div>
                                        <div class="option-param">${capacity?.value ?? ''}</div>
                                    </div>
                                </div>
                            </div>
                        </a>`
                $('#catalog').append(item)
            })
            if (response.data.length < 8) { $('#catalog-load').addClass('hide')}
        })
    })

    $('#sort').find('.dropdown-link').on('click', function () {
        $('#sort').find('.dropdown-link').removeClass('active')
        $(this).addClass('active')
        $('#sort').attr('data-sort-id', Number($(this).attr('data-sort-id')))
        $('#catalog-load').removeClass('hide')
        $('#catalog').attr('data-count', 0)
        let data = {
            category:  $('#categories').attr('data-category-slug'),
            sort:   Number($('#sort').attr('data-sort-id'))
        }
        $.ajax({
            type: 'GET',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                'X-localization': getLocale()
            },
            url: '/api/v1/products/filter',
            data:  data
        }).done(function (response) {
            $('#catalog').children().remove()
            $('#catalog').attr('data-count', (Number($('#catalog').attr('data-count')) + response.data.length))
            response.data.forEach(el => {
                image = el.image
                title = el.title
                slug = el.slug
                capacity = el.capacity
                let item = `<a href="${(getLocalPart())}/product/${slug}" class="catalog-item">
                            <div class="catalog-item__photo">
                                <img src="${image}" alt="${title}">
                            </div>
                            <div class="catalog-item__info">
                                <div class="info-title">${title}</div>
                                <div class="info-options">
                                    <div class="info-options__item">
                                        <div class="option-name">${capacity?.name ?? ''}</div>
                                        <div class="option-dash"></div>
                                        <div class="option-param">${capacity?.value ?? ''}</div>
                                    </div>
                                </div>
                            </div>
                        </a>`
                $('#catalog').append(item)
            })
            if (response.data.length < 8) { $('#catalog-load').addClass('hide')}
        })
    })

    //------------------- contacts form ----------------------

    $('#phone').mask('+38(999)999-99-99')

    $('#contacts-form').validate({
        ignore: [],
        errorElement: 'span',
        rules: {
            name: {
                required: true,
                minlength: 3,
                maxlength: 20
            },
            phone: {
                required: true,
            },
            email: {
                required: true,
                email:true
            },
            message: {
                required: true,
                minlength: 10,
            }
        },
        messages: {
            name: {
                required: fill,
                minlength: minimumLength + '3',
                maxlength: maximumLength + '20'
            },
            phone: {
                required: fill
            },
            email: {
                required: fill,
                email: getLocale() === "en"
                    ? "Please use different format!"
                    :  getLocale() === "ru"
                        ? "Пожалуйста, используйте другой формат!"
                        : "Будь ласка, перевірте формат введення!"
            },
            message : {
                required: fill,
                minlength: minimumLength + '10',
            }

        },
        submitHandler: function submitHandler(form, event) {
            event.preventDefault()
            let data = new FormData(form)
            $.ajax({
                type: 'POST',
                processData: false,
                contentType: false,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                    'X-localization': getLocale()
                },
                url: '/api/v1/feedback',
                data: data,
                success: function(){
                    $('.popup').removeClass('hidden')
                    $( '#contacts-form' ).each(function(){
                        this.reset();
                    });
                }
            });
        }
    });
//-------------------------- letter popup close ---------------------

    $('.letter-close').on('click', function () {
        $('.popup').addClass('hidden')
    })

//--------------------------- smooth scroll ---------------------------
    $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {
            // On-page links
            if (
                true
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top - 130
                    }, 1000, function () {
                        // Callback after animation
                        // Must change focus!
                        var $target = $(target);
                        $target.focus();
                        if ($target.is(":focus")) { // Checking if the target was focused
                            return false;
                        } else {
                            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        }
                        ;
                    });
                }
            }
        });

    //-------------------- product card ----------------------

    // $('#product-categories').find('div').on('click', function () {
    //     $('#product-categories').find('div').removeClass('active')
    //     $(this).addClass('active')
    //     if (Number($(this).attr('data-product-id')) === 1) {
    //         $('#product-desc').addClass('hide')
    //         $('#product-rec').removeClass('hide')
    //     }
    //     else {
    //         $('#product-desc').removeClass('hide')
    //         $('#product-rec').addClass('hide')
    //     }
    // })

    //------------------- hamburger ---------------------
    $('#nav-icon3').click(function () {
        $(this).toggleClass('open mobile');
        $('.mobilemenu').toggleClass('open');
        $('#header-left').toggleClass('hide');
        $('.header-wrapper').toggleClass('mobile');
        $('#search').toggleClass('hide');
    });
});
